import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { Proposal } from "../../../definitions/proposal";
import { ExchangeService } from "../../../services/api/exchange.service";
import { ExchangeActions } from "../../actions/exchange.actions";
import { FailState } from "../../models/fail-state";
import { ProposalsState } from "../../models/proposals-state";
import { AppState } from "../../reducers";
import { ProposalSelectors } from "../../selectors/proposal.selectors";

@Injectable()
export class ExchangeProposalGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ExchangeActions.proposal.get),
			withLatestFrom(this.store.select(ProposalSelectors.proposals)),
			switchMap(([action, state]) => {
				const proposal = this.getStoreValue(action, state);
				if (proposal) {
					return of(ExchangeActions.proposal.getSuccess(proposal));
				} else {
					return of(ExchangeActions.proposal.getApi({ id: action.id }));
				}
			})
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ExchangeActions.proposal.getApi),
			switchMap((action) =>
				this.exchangeService.proposal(action.id).pipe(
					map((proposal) => ExchangeActions.proposal.getSuccess(proposal)),
					catchError((error) =>
						of(ExchangeActions.proposal.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private exchangeService: ExchangeService
	) {}

	private getStoreValue(action, state: ProposalsState): Proposal {
		if (!_.has(state, "error") && !state.loading) {
			return null;
		}
		return _.find(_.get(state, "proposals", []), (p) => p.id === action.id);
	}
}
